var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlusPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_7061)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_173_7061)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 88,
    height: 119,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 60,
    cy: 57,
    r: 13,
    fill: "#23A26D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 60.798C66 61.014 65.9519 61.236 65.8498 61.452C65.7476 61.668 65.6154 61.872 65.4412 62.064C65.1467 62.388 64.8222 62.622 64.4557 62.772C64.0951 62.922 63.7046 63 63.2839 63C62.671 63 62.016 62.856 61.325 62.562C60.634 62.268 59.9429 61.872 59.2579 61.374C58.5669 60.87 57.9119 60.312 57.2869 59.694C56.668 59.07 56.1092 58.416 55.6104 57.732C55.1177 57.048 54.7211 56.364 54.4326 55.686C54.1442 55.002 54 54.348 54 53.724C54 53.316 54.0721 52.926 54.2163 52.566C54.3605 52.2 54.5889 51.864 54.9074 51.564C55.2919 51.186 55.7126 51 56.1572 51C56.3255 51 56.4937 51.036 56.644 51.108C56.8002 51.18 56.9384 51.288 57.0466 51.444L58.4407 53.406C58.5488 53.556 58.6269 53.694 58.681 53.826C58.7351 53.952 58.7651 54.078 58.7651 54.192C58.7651 54.336 58.7231 54.48 58.639 54.618C58.5608 54.756 58.4467 54.9 58.3025 55.044L57.8458 55.518C57.7797 55.584 57.7496 55.662 57.7496 55.758C57.7496 55.806 57.7556 55.848 57.7677 55.896C57.7857 55.944 57.8037 55.98 57.8157 56.016C57.9239 56.214 58.1102 56.472 58.3746 56.784C58.645 57.096 58.9334 57.414 59.2459 57.732C59.5704 58.05 59.8828 58.344 60.2013 58.614C60.5138 58.878 60.7722 59.058 60.9765 59.166C61.0065 59.178 61.0426 59.196 61.0846 59.214C61.1327 59.232 61.1808 59.238 61.2349 59.238C61.337 59.238 61.4151 59.202 61.4812 59.136L61.9379 58.686C62.0881 58.536 62.2323 58.422 62.3706 58.35C62.5088 58.266 62.647 58.224 62.7972 58.224C62.9114 58.224 63.0315 58.248 63.1637 58.302C63.2959 58.356 63.4342 58.434 63.5844 58.536L65.5734 59.946C65.7296 60.054 65.8378 60.18 65.9039 60.33C65.9639 60.48 66 60.63 66 60.798Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 78,
    width: 52,
    height: 5,
    rx: 2.5,
    fill: "#D8DBE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 88,
    width: 76,
    height: 50,
    rx: 4,
    fill: "url(#paint0_linear_173_7061)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_7061",
    x1: 60,
    y1: 16.7037,
    x2: 60,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_7061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_173_7061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 119,
    fill: "white",
    transform: "translate(16 32)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlusPhone);
export default __webpack_public_path__ + "static/media/ilus-phone.8f274178b047c3006c8fae7fcb33dcdf.svg";
export { ForwardRef as ReactComponent };